import { CircularProgress } from "@mui/material";
import { useTSData } from "../general/TSDataContext";

const SpinnerUi = ({ children }) => {
    const { isLoading } = useTSData();
    return<div style={{ position: "relative" }}>
          <div
            style={{
              opacity: isLoading ? 0.5 : 1,
              pointerEvents: isLoading ? "none" : "auto",
            }}
          >
            {children}
          </div>
    
          {isLoading && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 10, // Ensures the spinner is above other content
              }}
            >
              <CircularProgress />
            </div>
          )}
        </div>
}

export default SpinnerUi